import React, { useContext, useState } from "react";
import {
  COOKIE_NAME,
  COOKIE_QUERY_NAME,
  deleteCookie,
  gtmRegistration,
  validatePassword,
  POST_REG_FUNNEL_SHOW,
  POST_REG_FUNNEL_SHOW_REQUIRED,
  prepareRegistrationData,
  REGISTRATION_CONFIRMED,
  simplyClick,
} from "../../helpers";
import { apiRegistration } from "../../services/api";
import ButtonSubmit from "../ButtonSubmit";
import InputGlobal from "../InputGlobal";
import Eye from "../../images/eye.svg";
import EyeOff from "../../images/eye-off.svg";
import "./PasswordForm.scss";
import { errorEventsPassword, landingId } from "../../constants";
import { ContextProfileUser } from "../../lib/profileContext";
import Tooltip from "../Tooltip";

function PasswordForm() {
  const [passwordShow, setPasswordShow] = useState(false);
  const [errorPassword, setErrorPassword] = useState({
    password: null,
    terms: null,
    response: null,
  });
  const [responseError, setResponseError] = useState(null);
  const [checkBox, setCheckBox] = useState(false);
  const [termsError, setTermsError] = useState(null);
  const [loader, setLoader] = useState(false);
  const { data, setData } = useContext(ContextProfileUser);
  const [showTooltip, setShowTooltip] = useState(false);

  const toggleBtn = (e) => {
    e.preventDefault();
    setPasswordShow(!passwordShow);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setResponseError(null);
    setErrorPassword((prev) => ({ ...prev, response: null }));

    const { status, error = { text: "", type: "" } } = validatePassword(
      data.password
    );

    let hasError = false;

    if (error.type) {
      simplyClick(errorEventsPassword[error.type]);
    }

    if (!status) {

      setErrorPassword((prev) => ({ ...prev, password: error.text }));
      hasError = true;
    } else {
      setErrorPassword((prev) => ({ ...prev, password: null }));
    }

    if (!checkBox) {
      simplyClick("err_lnd_checkbox_nocheckbox");
      setErrorPassword((prev) => ({ ...prev, terms: true }));
      setTermsError(
        "Please accept our Terms of Use, Privacy Policy, Cookie Policy, Billing & Refund Policy, Consent Policy"
      );
      hasError = true;

    } else {
      setErrorPassword((prev) => ({ ...prev, terms: null }));
    }

    if (hasError) {
      return;
    }

    setLoader(true);
    apiRegistration(prepareRegistrationData(data), responseCb);
    simplyClick("cl_lnd_lt2_password_join");
  };

  const responseCb = (response) => {
    setLoader(false);
    if (response.status === 200) {
      const data = JSON.parse(response.responseText);

      if (data.success === true) {
        deleteCookie(COOKIE_QUERY_NAME);
        deleteCookie(COOKIE_NAME);
        gtmRegistration(data.data);

        if (data.data.onModeration === true) {
          window.location.href = "/moderation/";
        } else {
          if (
            data.data.confirmed == REGISTRATION_CONFIRMED &&
            data.data.access_token
          ) {
            if (
              data.data.reg_funnel_status == POST_REG_FUNNEL_SHOW ||
              data.data.reg_funnel_status == POST_REG_FUNNEL_SHOW_REQUIRED
            ) {
              window.location.href = "/wizard/";
            } else {
              window.location.href = "/app/";
            }
          } else {
            window.location.href = "/confirm/";
          }
        }
      }

      return;
    } else if (response.status === 422) {
      const data = JSON.parse(response.responseText);

      if (data.errors && data.errors.length > 0) {
        let errorText = "";

        for (let i = 0; i < data.errors.length; i++) {
          const error = data.errors[i];

          errorText += i > 0 ? " " + error.message : error.message;
        }

        setResponseError(errorText);
        return;
      }
    } else if (response.status === 403) {
      window.location.href = "/moderation/";
      return;
    }

    setResponseError(
      "Can't register your profile now. Please try again later."
    );
  };

  const handleAddPassword = ({ target: { value } }) => {
    setErrorPassword((prev) => ({ ...prev, password: null }));
    setShowTooltip(false);
    setData({ ...data, password: value });
  };
  const handleCheckBox = (e) => {
    setErrorPassword((prev) => ({ ...prev, terms: null }));
    setTermsError(false);
    setCheckBox(!checkBox);
    simplyClick("cl_lnd_lt2_password_checkbox");
  };

  const lndId =
    window.location.search === ""
      ? `?landing_id=${landingId}`
      : `&landing_id=${landingId}`;

  return (
    <div className="error__form-wrapper">
      {loader && (
        <div className="spin-loader">
          <span>Loading...</span>
        </div>
      )}

      <div className="user__form-top">
        <h3>My password</h3>
      </div>
      <form
        className="password__form"
        onSubmit={handleSubmit}
        autoComplete="off"
      >
        <div className="input__password-wrapper">
          <InputGlobal
            onChange={(e) => handleAddPassword(e)}
            placeholder={"Enter your password"}
            className={`input__global input__password ${
              errorPassword.password ? "input__error" : ""
            }`}
            name="password"
            value={data.password ?? ""}
            type={passwordShow ? "text" : "password"}
            autoComplete="password"
            onFocus={() => {
              setShowTooltip(true);
              simplyClick("cl_lnd_lt2_password_type_pass");
            }}
            onBlur={() => setShowTooltip(false)}
          />
          <button onClick={toggleBtn} className="logo__eye">
            {passwordShow ? (
              <img src={Eye} alt="icon" />
            ) : (
              <img src={EyeOff} alt="icon" />
            )}
          </button>
          <Tooltip
            text="Your password must be at least 5 characters long. You can recover it using the email you provided."
            showTooltip={showTooltip}
            className="password"
          />
        </div>
        {errorPassword.password && <p className="errorPassword">{errorPassword.password}</p>}
        <div className="form-group">
          <input
            checked={checkBox}
            onChange={(e) => handleCheckBox(e)}
            type="checkbox"
            id="remember_me"
            className={`checkBox ${termsError ? "checkBox__error" : ""}`}
            name="remember"
            value="1"
          />
          <label htmlFor="remember_me" className="checkbox-text">
            <span>
              I have read, understand and agree to&nbsp;
              <a href={`/terms-of-use${lndId}`} target="_blank">
                Terms of Use
              </a>
              ,&nbsp;
              <a href={`/privacy-policy${lndId}`} target="_blank">
                Privacy Policy
              </a>
              ,&nbsp;
              <a href={`/cookie-policy${lndId}`} target="_blank">
                Cookie policy
              </a>
              ,&nbsp;
              <a href={`/billing-policy${lndId}`} target="_blank">
                Billing
              </a>
              &nbsp;&&nbsp;
              <a href={`/refund-policy${lndId}`} target="_blank">
                Refund Policy
              </a>
              ,&nbsp;
              <a href={`/consent-policy${lndId}`} target="_blank">
                Consent Policy
              </a>
            </span>
          </label>
        </div>
        {termsError && <p className="errorPassword">{termsError}</p>}
        {responseError && <p className="errorPassword">{responseError}</p>}
        <ButtonSubmit
          className={"button__global button__password"}
          text={"Join now"}
        />
        <div className="progress__dots">
          <span className="active"></span>
          <span className="active"></span>
          <span className="active"></span>
          <span className="active"></span>
          <span className="active"></span>
          <span className="active"></span>
        </div>
      </form>
    </div>
  );
}

export default PasswordForm;
